import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { QueryVariable } from '../../domain/enrichment/EnrichmentDomain';
import { EnrichmentSchema } from '../../domain/enrichment/EnrichmentSchemaDomains';

export type QueryActions = 'CHANGE_QUERY' | 'CHANGE_QUERY_VARIABLE_SCHEMA' | 'CHANGE_QUERY_IS_UPDATE' | 'CLEAR_QUERY' | 'CHANGE_QUERY_DIRTY';

export const changeQuery = (payload: QueryVariable | null) =>
  ({
    type: 'CHANGE_QUERY',
    payload,
  }) as ReduxBaseAction<QueryVariable, QueryActions>;

export const changeQueryVariableSchema = (payload: EnrichmentSchema | null) =>
  ({
    type: 'CHANGE_QUERY_VARIABLE_SCHEMA',
    payload,
  }) as ReduxBaseAction<EnrichmentSchema | null, QueryActions>;

export const changeQueryIsUpdate = (payload: boolean) =>
  ({
    type: 'CHANGE_QUERY_IS_UPDATE',
    payload,
  }) as ReduxBaseAction<boolean, QueryActions>;

export const clearQuery = () =>
  ({
    type: 'CLEAR_QUERY',
    payload: void 0,
  }) as ReduxBaseAction<void, QueryActions>;

export const changeQueryDirty = (payload: boolean) =>
  ({
    type: 'CHANGE_QUERY_DIRTY',
    payload,
  }) as ReduxBaseAction<boolean, QueryActions>;
